var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M9.4,7.5c-1-0.1-1.8,0.6-1.9,1.6v22.5l2.5,5.5l0,0c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.7-0.1,0.9-0.3l0,0 l2.4-5.5c0.1-0.1,0.1-0.1,0.1-0.2V9.1c-0.1-1-1-1.7-2-1.6c0,0,0,0,0,0H9.4z M12.2,8.3c0.7,0,1.2,0.4,1.2,0.8v3H8.3v-3 c0-0.4,0.5-0.8,1.1-0.8H12.2z M8.3,12.9h2.2v18H8.3V12.9z M12,34.5H9.7l-1.3-2.9h4.9L12,34.5z M13.4,30.9h-2.2v-18h2.2V30.9z"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "8.4,31.6 9.7,34.5 12,34.5 13.3,31.6 "
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 11.2,
  y: 12.9,
  fill: "#FFDEAF",
  width: 2.2,
  height: 18
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 8.3,
  y: 12.9,
  fill: "#FFDEAF",
  width: 2.2,
  height: 18
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FA908A",
  d: "M8.3,9.1v3h5.1v-3c0-0.4-0.5-0.8-1.2-0.8H9.4C8.8,8.3,8.3,8.7,8.3,9.1z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M37.1,7.5H16.6c-0.2,0-0.4,0.2-0.4,0.4v29.2c0,0.2,0.2,0.4,0.4,0.4h20.5c0.2,0,0.4-0.2,0.4-0.4V7.9 C37.5,7.7,37.3,7.5,37.1,7.5z M36.7,36.7H16.9V8.3h19.8V36.7z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M16.9,8.3v28.4h19.8V8.3H16.9z M20.8,30.7c0-0.2,0.1-0.4,0.3-0.4h11.4c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4H21.1C20.9,31.1,20.8,30.9,20.8,30.7z M20.8,26.6c0-0.2,0.1-0.4,0.3-0.4h11.4c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4H21.1C20.9,27,20.8,26.8,20.8,26.6z M20.8,22.5c0-0.2,0.1-0.4,0.3-0.4h11.4c0.2,0,0.4,0.2,0.4,0.4 s-0.2,0.4-0.4,0.4H21.1C20.9,22.9,20.8,22.7,20.8,22.5z M20.8,18.4c0-0.2,0.1-0.4,0.3-0.4h11.4c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4H21.1C20.9,18.8,20.8,18.6,20.8,18.4z M20.8,14.3c0-0.2,0.1-0.4,0.3-0.4h11.4c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4H21.1C20.9,14.7,20.8,14.5,20.8,14.3z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M32.5,31.1c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H21.1c-0.2,0-0.3,0.2-0.3,0.4s0.1,0.4,0.3,0.4H32.5z "
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M32.5,27c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H21.1c-0.2,0-0.3,0.2-0.3,0.4s0.1,0.4,0.3,0.4H32.5z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M32.5,22.9c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H21.1c-0.2,0-0.3,0.2-0.3,0.4c0,0.2,0.1,0.4,0.3,0.4 L32.5,22.9z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M32.5,18.8c0.2,0,0.4-0.2,0.4-0.4S32.7,18,32.5,18H21.1c-0.2,0-0.3,0.2-0.3,0.4s0.1,0.4,0.3,0.4H32.5z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M32.5,14.7c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4H21.1c-0.2,0-0.3,0.2-0.3,0.4c0,0.2,0.1,0.4,0.3,0.4 H32.5z"
});

function SvgPencilAndPaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilAndPaper);
export default __webpack_public_path__ + "static/media/pencil_and_paper.155324ca7feca38637e5bf1fc7026018.svg";
export { ForwardRef as ReactComponent };